import { render, staticRenderFns } from "./follow-up-ranking.vue?vue&type=template&id=022e1723"
import script from "./follow-up-ranking.vue?vue&type=script&lang=ts"
export * from "./follow-up-ranking.vue?vue&type=script&lang=ts"
import style0 from "./follow-up-ranking.vue?vue&type=style&index=0&id=022e1723&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports